import { apiRequest } from '../utils/apiClient';
import type { Property } from '../mocks/properties';

// Special deals = curated featured listings, available to ACTIVE subscribers only.
// Backend GET /api/special-deals returns the same property shape as search/list
// (so PropertyCard renders them as-is); 403 when the caller has no active sub.
export async function listSpecialDeals(token: string): Promise<Property[]> {
  const res = await apiRequest<{ data: Property[] }>('/special-deals', { token });
  return res.data ?? [];
}
